// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-sent {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.confirmation-sent ftr-portal-badge {
    display: flex;
    justify-content: center;
  }

.confirmation-sent h1 {
    margin: 0;
    text-align: center;
  }

.confirmation-sent p {
    margin-bottom: 0;
  }

.confirmation-sent__email {
    font-weight: 700;
  }

.confirmation-sent .notification {
    margin-bottom: 0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
